if (!customElements.get('mf-product-story')) {
  customElements.define('mf-product-story', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const hotspots = Array.from(this.querySelectorAll('.mf-hotspot'));
      if (hotspots.length) {
        this.addEventListener('toggle', event => {
          if (!event.target.matches('.mf-hotspot') || !event.target.open) return;
          hotspots.forEach(point => { if (point !== event.target) point.open = false; });
        }, { ...options, capture: true });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          const point = hotspots.find(item => item.open);
          if (point) { point.open = false; point.querySelector('summary').focus(); }
        }, options);
        document.addEventListener('click', event => {
          if (!this.querySelector('.mf-story__photo--lining').contains(event.target)) hotspots.forEach(point => { point.open = false; });
        }, options);
        this.addEventListener('click', event => {
          const close = event.target.closest('[data-hotspot-close]');
          if (!close) return;
          const point = close.closest('.mf-hotspot');
          point.open = false;
          point.querySelector('summary').focus();
        }, options);
      }
      this.addEventListener('click', event => {
        const action = event.target.closest('[data-story-size], [data-story-shade], [data-story-offers]');
        if (!action) return;
        const entry = document.querySelector('[data-mf-open]');
        const main = entry?.closest('.shopify-section');
        if (!entry || !main) return;
        event.preventDefault();
        if (action.hasAttribute('data-story-size')) { action.closest('.mf-hotspot')?.removeAttribute('open'); entry.click(); return; }
        if (action.hasAttribute('data-story-shade')) {
          const shade = action.dataset.storyShade;
          const picker = main.querySelector('variant-selects');
          const radio = Array.from(picker?.querySelectorAll('input[type="radio"]') || []).find(input => input.value === shade);
          const select = Array.from(picker?.querySelectorAll('select') || []).find(input => Array.from(input.options).some(option => option.value === shade));
          const control = radio || select;
          if (!control) return;
          if (radio) radio.checked = true;
          else select.value = shade;
          control.dispatchEvent(new Event('change', { bubbles: true }));
          this.querySelectorAll('[data-story-shade]').forEach(button => {
            const selected = button.dataset.storyShade === shade;
            button.setAttribute('aria-pressed', String(selected));
            button.closest('.mf-shade').classList.toggle('is-selected', selected);
          });
          entry.click();
          return;
        }
        (main.querySelector('glass-quantity-breaks') || entry).scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        entry.focus({ preventScroll: true });
      }, options);
      const track = this.querySelector('[data-story-reviews]');
      if (!track) return;
      const previous = this.querySelector('[data-story-prev]');
      const next = this.querySelector('[data-story-next]');
      const update = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => {
        const card = track.querySelector('.mf-review');
        const distance = (card?.getBoundingClientRect().width || track.clientWidth) + parseFloat(getComputedStyle(track).gap || 0);
        track.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, { ...options, passive: true });
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}

